import Vue from 'vue'
import VueResource from 'vue-resource'
import UnaltorizedInterceptor from './interceptors'

Vue.use(VueResource)

const http = Vue.http
http.options.root = process.env.VUE_APP_BASE_API_URL
http.options.emulateJSON = true

// http.interceptors.push(interceptors)

const SetBearerToken = (token) => {
  http.headers.common['Authorization'] = `Bearer ${token}`
}

Vue.http.interceptors.push(UnaltorizedInterceptor)

export { http, SetBearerToken }
